document.addEventListener('DOMContentLoaded', () => {
  const scrollButtons = document.querySelectorAll('[data-scroll-to-next-section]');

  scrollButtons.forEach(scrollButton => {
    scrollButton.addEventListener('click', (event) => {
      event.preventDefault();
      let currentSection = scrollButton.closest('[id^="shopify-section-"]');

      if (currentSection) {
        let nextSection = currentSection.nextElementSibling;

        while (nextSection && !nextSection.id.startsWith('shopify-section-')) {
          nextSection = nextSection.nextElementSibling;
        }

        if (nextSection) {
          const header = document.querySelector('.header');
          let headerOffset = 0;
          if (header) {
            headerOffset = header.offsetHeight; 
          }

          const targetPosition = nextSection.getBoundingClientRect().top + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });

        } else {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'smooth'
          });
        }
      }
    });
  });
});